export default {
      id: "as-large-print-usage",
      viewBox: "0 0 56 56",
      url: "/" + "sprite.svg#as-large-print",
      toString: function () {
        return this.url;
      }
    }